export default function(){
    jQuery(window).on('scroll', function(){
        jQuery('body').toggleClass('is-scrolled', jQuery(window).scrollTop() > 60);
    });
}